import { useState, useEffect } from 'react';
import { RatingInner } from './RatingInner';
import { ThankYouInner } from './ThankYouInner';

import styles from './RatingCard.module.scss';

export const RatingCard = () => {
  const [selectedRating, setSelectedRating] = useState<number>();
  const [animate, setAnimate] = useState('');
  const [didSubmit, setDidSubmit] = useState<boolean>(false);

  const handleSubmit = () => {
    if (selectedRating > 0) {
      console.log('submit button pressed');
      setDidSubmit(true);
      setAnimate(styles.parent);
    }
  };

  return (
    <div className={animate}>
      <section className={styles.card}>
        {didSubmit ? (
          <ThankYouInner rating={selectedRating} />
        ) : (
          <RatingInner
            selectedRating={selectedRating}
            setSelectedRating={setSelectedRating}
            onSubmit={handleSubmit}
          />
        )}
      </section>
    </div>
  );
};
